module.exports = __webpack_public_path__ + "static/kb-cozumler-bd4114d28478b1457edebd704e475c1d.png";